<template>
<div class="AdminPanelEducation">
  <div class="page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class=" d-flex align-center pb-4 mb-4">
      <h1 class="font-lg">Управление обучающими материалами</h1>
    </div>
    <div>
      <v-btn
        large
        class="AdminPanelEducation__btn mb-4"
        color="white"
        outlined
        @click="openCreateModal"
      >
        Добавить обучающий материал
      </v-btn>
    </div>
    <TableEducation
      @deleteItem="attemptDeleteItem"
      @draftedEducation="unPublishedEducation"
      @publishedEducation="publishedEducation"
      @editItem="switchToEdit"
      @goToMaterial="goToMaterial"

    />
    <ModalCreateEducation
      :open-modal="showCreateModal"
      :updateItem="editedEducation"
      :isUpdate="isEditingEducation"
      :isCreate="isCreatingEducation"
      :isPreview="isPreviewEducation"
      @updateEducation="attemptUpdateEducation"
      @createEducation="attemptCreateEducation"
      @closeModal="closeCreateModal"
      @showPreview="showPreview"
      @returnToEdit="returnToEdit"

    />
    <ModalWithAction
      v-if="error.createEducation.length > 0"
      title=""
      image-slot
      :show-modal="error.createEducation.length > 0"
      :text="`Попробуйте еще раз или свяжитесь с менеджером ${parseDetailError(error.createEducation)}`"
      :cancel-button="true"
      :accept-button="'Связаться с менеджером'"
      @closeModal="closeErrorModal"
    >
      <template v-slot:image>
        <div class="d-flex justify-center">
          <v-img
            class="text-center"
            src="@/assets/images/adminPanel/failed.webp"
            max-width="86px"
          />
        </div>
      </template>
    </ModalWithAction>
    <ModalWithAction
      :title="successModalTitle"
      :image-slot="true"
      :show-modal="results.create.success || results.update.success || results.delete.success"
      :cancel-button="false"
      :width-modal="586"
      @closeModal="closeSuccesModal"
    >
      <template v-slot:image>
        <div class="d-flex justify-center">
          <v-img
            class="text-center"
            src="@/assets/images/adminPanel/success.webp"
            max-width="86px"
          />
        </div>
      </template>
    </ModalWithAction>
    <ModalWithAction
      :title="'Подтвердите удаление обучающего материла!'"
      :image-slot="false"
      :show-modal="showDeleteModal"
      :cancel-button="true"
      :accept-button="'Подтверждаю'"
      :width-modal="586"
      @accept="deleteItem"
      @closeModal="closeDeleteModal"
    />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TableEducation from '@/components/admin-panel/TableEducation.vue';
import ModalCreateEducation from '@/components/admin-panel/Modal/ModalCreateEducation.vue';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';

/**
 * Компонент: AdminPanelEducation
 * Описание:
 */
export default {
  name: 'AdminPanelEducation',

  components: { ModalWithAction, ModalCreateEducation, TableEducation },

  props: {},

  data() {
    const showCreateModal = false;
    const showSuccessModal = false;
    const showFailedModal = false;
    const showUpdateModal = false;
    const showDeleteModal = false;
    const deleteItemId = null;
    return {
      showCreateModal,
      showSuccessModal,
      showFailedModal,
      showUpdateModal,
      showDeleteModal,
      deleteItemId,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      error: 'education/Education/getError',
      results: 'education/Education/getResults',
      allMaterials: 'education/Education/allMaterials',
      editedEducation: 'education/Education/getCurrentEducation',
      currentStepCreating: 'education/Education/getCurrentStepCreating',
      isCreatingEducation: 'education/Education/isCreatingEducation',
      isEditingEducation: 'education/Education/isEditingEducation',
      isPreviewEducation: 'education/Education/isPreviewEducation',
    }),
    breadcrumbs() {
      return [
        { title: 'Админка', url: '/admin-panel' },
        { title: 'Управление обучающими материалами', url: '' },
      ];
    },
    successModalTitle() {
      if (this.results.create.success) {
        return 'Обучающий материал <br> успешно добавлен';
      }
      if (this.results.update.success) {
        return 'Обучающий материал <br> успешно обновлен';
      }
      if (this.results.delete.success) {
        return 'Обучающий материал <br> успешно удален';
      }
      return '';
    },

  },

  watch: {},

  created() {
  },

  async mounted() {
    await this.fetchAllEducation();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      createEducation: 'education/Education/createEducation',
      fetchAllEducation: 'education/Education/fetchAllEducation',
      deleteEducation: 'education/Education/deleteEducation',
      publishEducation: 'education/Education/publishEducation',
      unPublishEducation: 'education/Education/unPublishEducation',
      detailEducation: 'education/Education/fetchDetailEducation',
      updateEducation: 'education/Education/partialUpdateEducation',
    }),
    ...mapMutations({
      clearError: 'education/Education/CLEAR_ERROR',
      clearResults: 'education/Education/CLEAR_RESULTS',
      clearCurrentEducation: 'education/Education/CLEAR_CURRENT_EDUCATION',
      setStepCreating: 'education/Education/SET_STEP_CREATING'
    }),

    goToMaterial(education) {
      this.$router.push(`/training-materials/${education.id}`);
    },

    openCreateModal() {
      this.setStepCreating('status_creating');
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
      this.clearCurrentEducation();
      this.setStepCreating(null);
    },
    parseDetailError(error) {
      let str = '';
      if (typeof error === 'object' && error.length > 0) {
        error.forEach((item) => {
          for (const [key, value] of Object.entries(item)) {
            str += `<br>${key}: ${value}`;
          }
        });
        return str;
      }
        if (typeof error === 'object') {
          for (const [key, value] of Object.entries(error)) {
            str += `<br>${key}: ${value}`;
          }
        }
    },
    closeErrorModal() {
      this.clearError();
    },
    closeSuccesModal() {
      this.clearResults();
    },
    closeDeleteModal() {
      this.deleteItemId = null;
      this.showDeleteModal = false;
    },
    showPreview() {
      this.setStepCreating('status_preview');
    },
    returnToEdit() {
      this.setStepCreating('status_editing');
    },
    async switchToEdit(education) {
      this.setStepCreating('status_editing');
      await this.getDetailEducation(education);
    },
    async attemptCreateEducation(data) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return undefined;
      const payload = {
        data,
      };
      const res = await this.createEducation(payload);
      if (res.success) {
        this.showCreateModal = false;
        await this.fetchAllEducation();
      }
      return res;
    },
    async attemptUpdateEducation(data) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return undefined;
      const payload = {
        id: data.id,
        data,
      };
      const res = await this.updateEducation(payload);
      if (res.success) {
        this.showCreateModal = false;
        await this.fetchAllEducation();
      }
      return res;
    },
    attemptDeleteItem(item) {
      this.deleteItemId = item.id;
      this.showDeleteModal = true;
    },
    async deleteItem() {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      const data = {
        id: this.deleteItemId,
      };
      const res = await this.deleteEducation(data);
      if (res.success) {
        await this.fetchAllEducation();
        this.showDeleteModal = false;
      }
    },
    async publishedEducation(education) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      const res = await this.publishEducation(education);
      if (res.success) {
        await this.fetchAllEducation();
      }
    },
    async unPublishedEducation(education) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      const res = await this.unPublishEducation(education);
      if (res.success) {
        await this.fetchAllEducation();
      }
    },
    async getDetailEducation(education) {
      const res = await this.detailEducation(education);
      if (res.success) {
        this.showCreateModal = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.AdminPanelEducation {
  /* Стили компонента */
  & .AdminPanelEducation__btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    height: 100%;
    font-size: 16px;
    padding: 10px 16px;
    margin-left: 8px;
    ::v-deep span{
      line-height: 24px;
    }
  }
}
</style>
